/**
 * NSM gallery — single source of truth for gallery page, home preview, and model detail pages.
 * Each item: name, slug, image (cover), alt, category, images (all for /gallery/:slug).
 */

/* eslint-disable max-len */
import a01 from "../assets/gallery/anastasiia-f-107/01.webp";
import a02 from "../assets/gallery/anastasiia-f-107/02.webp";
import a03 from "../assets/gallery/anastasiia-f-107/03.webp";
import a04 from "../assets/gallery/anastasiia-f-107/04.webp";
import a05 from "../assets/gallery/anastasiia-f-107/05.webp";
import a06 from "../assets/gallery/anastasiia-f-107/06.webp";
import a07 from "../assets/gallery/anastasiia-f-107/07.webp";
import a08 from "../assets/gallery/anastasiia-f-107/08.webp";
import b01 from "../assets/gallery/arina-m-44/01.webp";
import b02 from "../assets/gallery/arina-m-44/02.webp";
import b03 from "../assets/gallery/arina-m-44/03.webp";
import b04 from "../assets/gallery/arina-m-44/04.webp";
import b05 from "../assets/gallery/arina-m-44/05.webp";
import b06 from "../assets/gallery/arina-m-44/06.webp";
import b07 from "../assets/gallery/arina-m-44/07.webp";
import b08 from "../assets/gallery/arina-m-44/08.webp";
import b09 from "../assets/gallery/arina-m-44/09.webp";
import c01 from "../assets/gallery/carolin-b-112/01.webp";
import c02 from "../assets/gallery/carolin-b-112/02.webp";
import c03 from "../assets/gallery/carolin-b-112/03.webp";
import c04 from "../assets/gallery/carolin-b-112/04.webp";
import c05 from "../assets/gallery/carolin-b-112/05.webp";
import c06 from "../assets/gallery/carolin-b-112/06.webp";
import c07 from "../assets/gallery/carolin-b-112/07.webp";
import c08 from "../assets/gallery/carolin-b-112/08.webp";
import d01 from "../assets/gallery/ceyla-a-79/01.webp";
import d02 from "../assets/gallery/ceyla-a-79/02.webp";
import d03 from "../assets/gallery/ceyla-a-79/03.webp";
import d04 from "../assets/gallery/ceyla-a-79/04.webp";
import d05 from "../assets/gallery/ceyla-a-79/05.webp";
import e01 from "../assets/gallery/daria-k-52/01.webp";
import e02 from "../assets/gallery/daria-k-52/02.webp";
import e03 from "../assets/gallery/daria-k-52/03.webp";
import e04 from "../assets/gallery/daria-k-52/04.webp";
import e05 from "../assets/gallery/daria-k-52/05.webp";
import e06 from "../assets/gallery/daria-k-52/06.webp";
import e07 from "../assets/gallery/daria-k-52/07.webp";
import f01 from "../assets/gallery/daryna-b-90/01.webp";
import f02 from "../assets/gallery/daryna-b-90/02.webp";
import f03 from "../assets/gallery/daryna-b-90/03.webp";
import f04 from "../assets/gallery/daryna-b-90/04.webp";
import f05 from "../assets/gallery/daryna-b-90/05.webp";
import f06 from "../assets/gallery/daryna-b-90/06.webp";
import f07 from "../assets/gallery/daryna-b-90/07.webp";
import f08 from "../assets/gallery/daryna-b-90/08.webp";
import f09 from "../assets/gallery/daryna-b-90/09.webp";
import f10 from "../assets/gallery/daryna-b-90/10.webp";
import f11 from "../assets/gallery/daryna-b-90/11.webp";
import f12 from "../assets/gallery/daryna-b-90/12.webp";
import f13 from "../assets/gallery/daryna-b-90/13.webp";
import f14 from "../assets/gallery/daryna-b-90/14.webp";
import g01 from "../assets/gallery/diana-k-65/01.webp";
import g02 from "../assets/gallery/diana-k-65/02.webp";
import g03 from "../assets/gallery/diana-k-65/03.webp";
import g04 from "../assets/gallery/diana-k-65/04.webp";
import g05 from "../assets/gallery/diana-k-65/05.webp";
import g06 from "../assets/gallery/diana-k-65/06.webp";
import g07 from "../assets/gallery/diana-k-65/07.webp";
import g08 from "../assets/gallery/diana-k-65/08.webp";
import g09 from "../assets/gallery/diana-k-65/09.webp";
import g10 from "../assets/gallery/diana-k-65/10.webp";
import h01 from "../assets/gallery/elen-f-106/01.webp";
import h02 from "../assets/gallery/elen-f-106/02.webp";
import h03 from "../assets/gallery/elen-f-106/03.webp";
import h04 from "../assets/gallery/elen-f-106/04.webp";
import h05 from "../assets/gallery/elen-f-106/05.webp";
import h06 from "../assets/gallery/elen-f-106/06.webp";
import i01 from "../assets/gallery/liza-t-73/01.webp";
import i02 from "../assets/gallery/liza-t-73/02.webp";
import i03 from "../assets/gallery/liza-t-73/03.webp";
import i04 from "../assets/gallery/liza-t-73/04.webp";
import i05 from "../assets/gallery/liza-t-73/05.webp";
import j01 from "../assets/gallery/madita-j-94/01.webp";
import j02 from "../assets/gallery/madita-j-94/02.webp";
import j03 from "../assets/gallery/madita-j-94/03.webp";
import j04 from "../assets/gallery/madita-j-94/04.webp";
import j05 from "../assets/gallery/madita-j-94/05.webp";
import j06 from "../assets/gallery/madita-j-94/06.webp";
import j07 from "../assets/gallery/madita-j-94/07.webp";
import j08 from "../assets/gallery/madita-j-94/08.webp";
import j09 from "../assets/gallery/madita-j-94/09.webp";
import j10 from "../assets/gallery/madita-j-94/10.webp";
import j11 from "../assets/gallery/madita-j-94/11.webp";
import j12 from "../assets/gallery/madita-j-94/12.webp";
import k01 from "../assets/gallery/oksana-t-88/01.webp";
import k02 from "../assets/gallery/oksana-t-88/02.webp";
import k03 from "../assets/gallery/oksana-t-88/03.webp";
import k04 from "../assets/gallery/oksana-t-88/04.webp";
import k05 from "../assets/gallery/oksana-t-88/05.webp";
import l01 from "../assets/gallery/polina-g-43/01.webp";
import l02 from "../assets/gallery/polina-g-43/02.webp";
import l03 from "../assets/gallery/polina-g-43/03.webp";
import l04 from "../assets/gallery/polina-g-43/04.webp";
import l05 from "../assets/gallery/polina-g-43/05.webp";
import l06 from "../assets/gallery/polina-g-43/06.webp";
/* eslint-enable max-len */

const CATEGORY = "NSM 2026";

export const galleryItems = [
  { name: "Anastasiia F", slug: "anastasiia-f-107", image: a01, alt: "Anastasiia F — Next Super Model gallery, NSM 2026", category: CATEGORY, images: [a01, a02, a03, a04, a05, a06, a07, a08] },
  { name: "Arina M", slug: "arina-m-44", image: b01, alt: "Arina M — Next Super Model gallery, NSM 2026", category: CATEGORY, images: [b01, b02, b03, b04, b05, b06, b07, b08, b09] },
  { name: "Carolin B", slug: "carolin-b-112", image: c01, alt: "Carolin B — Next Super Model gallery, NSM 2026", category: CATEGORY, images: [c01, c02, c03, c04, c05, c06, c07, c08] },
  { name: "Ceyla A", slug: "ceyla-a-79", image: d01, alt: "Ceyla A — Next Super Model gallery, NSM 2026", category: CATEGORY, images: [d01, d02, d03, d04, d05] },
  { name: "Daria K", slug: "daria-k-52", image: e01, alt: "Daria K — Next Super Model gallery, NSM 2026", category: CATEGORY, images: [e01, e02, e03, e04, e05, e06, e07] },
  { name: "Daryna B", slug: "daryna-b-90", image: f01, alt: "Daryna B — Next Super Model gallery, NSM 2026", category: CATEGORY, images: [f01, f02, f03, f04, f05, f06, f07, f08, f09, f10, f11, f12, f13, f14] },
  { name: "Diana K", slug: "diana-k-65", image: g01, alt: "Diana K — Next Super Model gallery, NSM 2026", category: CATEGORY, images: [g01, g02, g03, g04, g05, g06, g07, g08, g09, g10] },
  { name: "Elen F", slug: "elen-f-106", image: h01, alt: "Elen F — Next Super Model gallery, NSM 2026", category: CATEGORY, images: [h01, h02, h03, h04, h05, h06] },
  { name: "Liza T", slug: "liza-t-73", image: i01, alt: "Liza T — Next Super Model gallery, NSM 2026", category: CATEGORY, images: [i01, i02, i03, i04, i05] },
  { name: "Madita J", slug: "madita-j-94", image: j01, alt: "Madita J — Next Super Model gallery, NSM 2026", category: CATEGORY, images: [j01, j02, j03, j04, j05, j06, j07, j08, j09, j10, j11, j12] },
  { name: "Oksana T", slug: "oksana-t-88", image: k01, alt: "Oksana T — Next Super Model gallery, NSM 2026", category: CATEGORY, images: [k01, k02, k03, k04, k05] },
  { name: "Polina G", slug: "polina-g-43", image: l01, alt: "Polina G — Next Super Model gallery, NSM 2026", category: CATEGORY, images: [l01, l02, l03, l04, l05, l06] },
];

/** Number of gallery items to show on the home page preview */
export const HOME_PREVIEW_COUNT = 6;

/** First 6 items for home gallery preview */
export const homePreviewItems = galleryItems.slice(0, HOME_PREVIEW_COUNT);

/** Find gallery item by slug for detail page */
export function getGalleryItemBySlug(slug) {
  return galleryItems.find((item) => item.slug === slug) || null;
}

/** @deprecated Use getGalleryItemBySlug */
export function getModelBySlug(slug) {
  return getGalleryItemBySlug(slug);
}

export default galleryItems;
